import { CustomForm, CustomFormInputField, CustomFormSelection, errorMessageResult, FormCategories, isInputField } from "../../../DTOs";
import { basicValidation } from "../basicValidation";
import { assertNever } from "../../../util";

export const customFormValidation = {

    customFormTemplate:{
        id: (value: string) => basicValidation.resourceId.isValid(value)
    },

    customForm:{
        customFormId: (value: string) => basicValidation.resourceId.isValid(value),
        key:(value:string) => basicValidation.resourceId.isValid(value),
        category: (value: string) => typeof(value) === 'string' && FormCategories.find(c => c === value) !== undefined,
        publicLinkKey: (value:string) => basicValidation.resourceId.isValidOrEmpty(value),
        testAnswerCount: (value: number) => basicValidation.validateInteger(value, 1, 100),
    },
    
    customFormAnswer:{
        id: (value: string) => basicValidation.resourceId.isValid(value),
        selection:{
            object:(value:CustomFormSelection) => validateSelection(value),
            fieldId: (value:string) => validateSelectionFieldId(value),
            value:(value:string) => validateSelectionFieldValue(value)
        },
        selections: (values:CustomFormSelection[]) => validateSelectionList(values),
        deepPartialSelections:(selections:CustomFormSelection[], form:CustomForm) => 
            deepValidatePartialSelection(selections, form),
        deepSelections:(selections:CustomFormSelection[], form:CustomForm) => 
            deepValidateSelections(selections, form)
    }
};

function validateSelectionList(values:CustomFormSelection[])
{
    return Array.isArray(values) && values.every(v => validateSelection(v))
            && basicValidation.arrayStringsAreUnique(values.map(v => v.fieldId));
}

function validateSelection(value:CustomFormSelection)
{
    return typeof(value) === 'object' && typeof(value.fieldId) === 'string' && typeof(value.value) === 'string'
        && validateSelectionFieldId(value.fieldId) && validateSelectionFieldValue(value.value);
}

function validateSelectionFieldId(value:string)
{
    return basicValidation.resourceId.isValid(value)
}

function validateSelectionFieldValue(value:string)
{
    return basicValidation.validateString(value, false, false, 0, 1000);
}

function deepValidateSelections(selections:CustomFormSelection[], form:CustomForm):errorMessageResult
{   
    const basicValidation = validateSelectionList(selections);
    if(!basicValidation)
        return { valid:false, message:'invalid selection data structure'};

    for(const formField of form.fields)
    {
        if(isInputField(formField))
        {
            const formFieldSelections = selections.filter(s => s.fieldId === formField.fieldId);

            if(formFieldSelections.length === 0)
                return { valid:false, message:`missing selection: ${formField.fieldId}`};

            if(formFieldSelections.length > 1)
                return { valid:false, message:`duplicate selection: ${formField.fieldId}`};


            if(!validateSelectionValue(formFieldSelections[0], formField))
                return { valid:false, message:`invalid selection: ${formField.fieldId}`};
        }
    }
    
    return { valid:true};
}

function deepValidatePartialSelection(selections:CustomFormSelection[], form:CustomForm):errorMessageResult
{
    const basicValidation = validateSelectionList(selections);
    if(!basicValidation)
        return { valid:false, message:'invalid selection data structure'};

    for(const selectionField of selections)
    {
        const formFields = form.fields.filter(ff => ff.fieldId === selectionField.fieldId);

        if(formFields.length === 0)
            return { valid:false, message:`invalid selection fieldId: ${selectionField.fieldId}`};

        if(formFields.length > 1)
            return { valid:false, message:`duplicate selection: ${selectionField.fieldId}`};

        if(isInputField(formFields[0]))
        {
            if(!validateSelectionValue(selectionField, formFields[0]))
                return { valid:false, message:`invalid selection: ${selectionField.fieldId}`};
        }
    }
    
    return { valid:true};
}

function validateSelectionValue(selection:CustomFormSelection, field:CustomFormInputField):errorMessageResult
{
    if(!validateSelectionFieldValue)
        return { valid:false, message:`invalid basic selection value: ${selection.value}`};


    if(field.type === 'RadioButtonColumn' || field.type === 'RadioButtonRow')    
    {
        if(field.options.find(o => o.value === selection.value) === undefined)
            return { valid:false, message:`invalid selection value option: ${selection.value}`};

        return { valid:true };
    }
    else if(field.type === 'MatrixRadioButtons')
    {
        const allOptions = field.sections.flatMap(s => s.rows.flatMap(r => r?.options));
        if(allOptions.find(o => o?.value === selection.value) === undefined)
            return { valid:false, message:`invalid selection value option: ${selection.value}`};

        return { valid:true };
    }
    else if(field.type === 'Suggester')
        return { valid:true };

    else if(field.type === 'FreeText')
        return { valid:true };

    else if(field.type === 'FileUpload')
        return { valid:true };

    else if(field.type === 'CustomComponent')
        return { valid:true };

    else {
        assertNever(field);
    }

    throw new Error('unknown field type: ' + field.type);
}